export default __webpack_public_path__ + "static/media/DINNextCYR-Regular.42a72ad6.woff2";